var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLibStorage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 18,
  viewBox: "0 0 23 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.2531 16.5138H21.4031V16.3638V12.6437V12.4937H21.2531H1.60401H1.45401V12.6437V16.3638V16.5138H1.60401H21.2531ZM21.2531 11.7309H21.4031V11.5809V7.32938V7.17938H21.2531H1.60401H1.45401V7.32938V11.5809V11.7309H1.60401H21.2531ZM21.2531 6.41651H21.4031V6.26651V2.01502V1.86502H21.2531H1.60401H1.45401V2.01502V6.26651V6.41651H1.60401H21.2531ZM22.7071 17.2767H0.15V1.10215H22.7071V12.6437V17.2767Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17002 4.5222V3.75933H14.2861V4.5222H8.17002Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 0.3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17002 9.83656V9.07369H14.2861V9.83656H8.17002Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 0.3
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17002 14.8849V14.122H14.2861V14.8849H8.17002Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 0.3
})));
export default SvgLibStorage;